import { SearchInput } from '../../../../common/components/SearchInput'
import { useDebounce } from '../../../../common/hooks/useDebounce'
import { useStateCallback } from '../../../../common/hooks/useStateCallback'
import { IExportClient } from '../../../../common/interfaces'
import { useSolicitudes } from '../../hooks/useSolicitudes'
import { Export } from '../Export'
import { ScheduledRescueTable } from '../tables/ScheduledRescueTable'

export const ScheduledRescueTab = () => {
  const [search, setSearch] = useStateCallback<string>('')
  const debouncedSearch = useDebounce(search, 500)
  const [filters, setFilters] = useStateCallback<any>({

    status: '',
    scheduled_rescue: true,
  })

  const { exportMovements } = useSolicitudes()

  const handleExcelDownload = () => {
    let ex = {
      filter: {}, // si deseas incluir filtros como fecha, fondo, etc.
      search: search,
    } as IExportClient
    exportMovements.mutate(ex)
  }

  return (
    <>
      <div className='card border-0 pt-5 border-radius-20px'>
        <div className='card-header border-bottom-0 mt-3'>
          <div className='d-flex align-items-center gap-5'>
            <SearchInput
              placeholder='🔍︎ Buscar suscripción'
              search={search}
              setSearch={setSearch}
            />
          </div>
          {/*    <button
            style={{
              backgroundColor: '#007BC3',
              color: 'white',
              width: '180px',
              height: '42px',
            }}
            onClick={handleExcelDownload}
            className='btn text-end cursor-pointer w-200px'
          >
            <img
              style={{ marginRight: '5px' }}
              src={toAbsoluteUrl('/✅ Web - Mm/donwload.svg')}
              alt='plus'
              className='w-15px'
            />
            Exportar Movimientos
          </button> */}
        </div>
        <Export />
        <ScheduledRescueTable
          search={search.length > 2 ? debouncedSearch! : ''}
          setSearch={setSearch}
          selectedSuscriptions={[]} // o tu estado real si ya lo tienes
          setSelectedSuscriptions={() => {}} // o tu setter real
          mutationSuccess={false} // o tu estado real
          filters={filters}
          setFilters={setFilters}
        />
      </div>
    </>
  )
}
